<template>
  <div class="premium-tab-content">
    <!-- Seção Situação Tributária -->
    <div class="premium-card-section mb-4">
      <div class="modal-section-title mb-3">
        <i class="fa fa-tag mr-2 text-primary"></i> Enquadramento IPI
      </div>
      <b-row>
        <b-col md="12" class="mb-3">
          <b-form-group label="CST - Situação Tributária" label-class="modal-label-premium">
            <b-form-select 
              v-model="local.OP_IPI_SITUACAO_TRIBUTARIA" 
              :options="sitTribOptions" 
              class="rounded-pill shadow-xs custom-select-premium" 
              @change="emit" 
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Cód. Enquadramento Legal" label-class="modal-label-premium">
            <b-form-input v-model="local.TX_IPI_CODIGO_ENQUAD_LEGAL" class="rounded-pill shadow-xs" placeholder="999" @input="emit" />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="CNPJ do Produtor" label-class="modal-label-premium">
            <b-form-input v-model="local.TX_IPI_CNPJ_PRODUTOR" class="rounded-pill shadow-xs" placeholder="00.000.000/0000-00" @input="emit" />
          </b-form-group>
        </b-col>
      </b-row>
    </div>

    <!-- Seção Valores -->
    <div class="premium-card-section bg-soft-info p-3 rounded-lg border-info-light">
      <div class="modal-section-title mb-3 text-info">
        <i class="fa fa-calculator mr-2"></i> Cálculos e Valores
      </div>
      <b-row>
        <b-col md="4">
          <b-form-group label="Base de Cálculo" label-class="modal-label-premium">
            <vue-autonumeric
              v-model="local.VL_IPI_BASE_CALC"
              :options="autonumericOptions.valor"
              class="form-control rounded-pill shadow-xs text-right bg-white"
              @input="emit"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Alíquota %" label-class="modal-label-premium">
            <vue-autonumeric
              v-model="local.VL_IPI_ALIQUOTA"
              :options="autonumericOptions.percentual"
              class="form-control rounded-pill shadow-xs text-right bg-white"
              @input="emit"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Valor do IPI" label-class="modal-label-premium">
            <vue-autonumeric
              v-model="local.VL_IPI"
              :options="autonumericOptions.valor"
              class="form-control rounded-pill shadow-xs text-right font-weight-bold text-primary bg-white"
              @input="emit"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import VueAutonumeric from 'vue-autonumeric'

export default {
  name: 'NfeProdutoIpi',
  components: { VueAutonumeric },
  props: { value: { type: Object, default: () => ({}) } },
  data() {
    return {
      local: {},
      autonumericOptions: {
        valor: {
          digitGroupSeparator: '.',
          decimalCharacter: ',',
          decimalPlaces: 2,
          minimumValue: '0'
        },
        percentual: {
          digitGroupSeparator: '.',
          decimalCharacter: ',',
          decimalPlaces: 2,
          minimumValue: '0'
        }
      },
      sitTribOptions: [
        { value: '00', text: '00 - Entrada com Recuperação de Crédito' },
        { value: '01', text: '01 - Entrada Tributada com Alíquota Zero' },
        { value: '02', text: '02 - Entrada Isenta' },
        { value: '03', text: '03 - Entrada Não-Tributada' },
        { value: '04', text: '04 - Entrada Imune' },
        { value: '05', text: '05 - Entrada com Suspensão' },
        { value: '49', text: '49 - Outras Entradas' },
        { value: '50', text: '50 - Saída Tributada' },
        { value: '51', text: '51 - Saída Tributada com Alíquota Zero' },
        { value: '52', text: '52 - Saída Isenta' },
        { value: '53', text: '53 - Saída Não-Tributada' },
        { value: '54', text: '54 - Saída Imune' },
        { value: '55', text: '55 - Saída com Suspensão' },
        { value: '99', text: '99 - Outras Saídas' }
      ]
    }
  },
  watch: {
    value: { handler(v) { this.local = v || {} }, immediate: true }
  },
  methods: {
    emit() {
      this.$emit('input', this.local)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/faturamento/nfe/partials/NfeProdutoIpi.vue